import PdpHero from  "./PdpHero";
import PdpSteakTemperature from  "./PdpSteakTemperature";
//import PdpData from './pdpData.json';
import PdpAccordion from './PdpAccordion';
import PdpModal from "./PdpModal";
import PdpAddToCartBtn from "./PdpAddToCartBtn";
import PdpAddToCartFixBtn from "./PdpAddToCartFixBtn";

export default class PdpLandingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModifierGroup: false,
            showHideModal: false,
            dropdownFilterData: [],
            allData: this.props.data,
            isOnline: this.props.isOnline,
            modalTitle: '',
            selectedRootModifiers: [],
            selectedMenuId: -1,
            val: false,
            selectedSubItems: [],
            accordionList: [],
            parentId: -1,
            selectedMap: new Map(),
            finalModalList: [],
            finalAccordionList: [],
            dataChoiceAttributeIds: [],
            finalSteakTempList: [],
            modalListWithParent: [],
            steakData: [],
            minSelect: '',
            maxSelect: '',
            parentGrpToCountMap: new Map(),
            idMaps: new Map(),
            updatedTotalPrice: this.setInitialPrice(),
            count: 1,
            defaultSelected: [],
            priceSplitUp: new Map(),
            selectedModifiersList: new Map(),
            defaultModifiersList: new Map(),
            isEditMode: (this.props.data.CartItem && this.props.data.CartItem.id != 0) ? true : false,
            editValues: (this.props.data.CartItem && this.props.data.CartItem.choices) ? this.props.data.CartItem.choices.map(a => "" + a.optionid) : [],
            defaultModifier: new Map()

        }
        this.state.isModifierGroup = this.state.allData.ModifierGroup != null;
        this.handleClick = this.handleClick.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.dataChoiceIds = this.dataChoiceIds.bind(this);
        this.getParentIds = this.getParentIds.bind(this);
        this.getParentIdByValue = this.getParentIdByValue.bind(this);
        this.checkMaxCount = this.checkMaxCount.bind(this);
        this.disclaimers = this.props.disclaimers;
        this.trademarks = this.props.trademarks;
        this.AcceptOver21 = this.AcceptOver21.bind(this);
        this.modalClose = this.modalClose.bind(this);
        this.pushAppbViewItemToGTMDataLayer = this.pushAppbViewItemToGTMDataLayer.bind(this);
    }
    setInitialPrice() {
        return this.props.data.MenuItem.CalcPrice;
    }

    getSelectedModiferDetails(id) {
        let obj = {};
        if (this.state.selectedModifiersList.size > 0)
            for (let items of this.state.selectedModifiersList.values()) {
                items.map(a => {
                    if (a.value == id) obj = a;
                })
            }
        return obj;
    }
    
    getAllselectedChildModifiers(parentId, id, isNested) {
        let selectedItems = [];
        let tempList = this.state.selectedModifiersList.get(parentId);

        if (this.state.defaultModifiersList.has(parentId) && this.state.defaultModifiersList.get(parentId).length > 0) {
            tempList = this.state.defaultModifiersList.get(parentId);
        }
        if (tempList) {
            tempList.map((lst, index) => {
                if (isNested == true) {
                    if (lst.parentOptionGroupId == id) {
                        selectedItems.push(lst);
                    }
                } else {
                    if (lst.parentGroupId == id) {
                        selectedItems.push(lst);
                    }
                }
            });
        }
        return selectedItems;
    }

    getCaloriesDetails(modifiers, selectedArray) {
        let calText;
        let arr = JSON.parse(JSON.stringify(selectedArray));

        modifiers.map(modifier => {
            if (arr.indexOf(modifier.MenuItemDetail.Id) > -1) {
                if (modifier.MenuItemDetail.Name == "Extra") {
                    if (modifier.MenuItemDetail.BaseCalories > 0 && modifier.MenuItemDetail.BaseCalories != undefined) {
                        calText = this.state.allData.CalorieAdds + " " + modifier.MenuItemDetail.BaseCalories + " " + this.state.allData.CalorieAbbr;
                    }
                }
                if (modifier.MenuItemDetail.Name == "Remove") {
                    if (modifier.MenuItemDetail.BaseCalories < 0 && modifier.MenuItemDetail.BaseCalories != undefined) {
                        calText = this.state.allData.CalorieSubtracts + " " + (-1 * modifier.MenuItemDetail.BaseCalories) + " " + this.state.allData.CalorieAbbr;
                    }
                }
            }
        });

        return calText;
    }
    setDefaultModifiersList(obj, modifierId) {
        let pid = (modifierId) ? modifierId : (this.state.selectedMenuId != -1) ? this.state.selectedMenuId : obj.parentModifierId;
        // let pid = (this.state.selectedMenuId != -1) ? this.state.selectedMenuId : obj.parentModifierId;
        let tempList = this.state.defaultModifiersList.get(pid) || [];
        tempList.push(obj);
        this.state.defaultModifiersList.set(pid, tempList);
    }
    setSelectedModifiersList(obj, modifierId) {
        let getIndex = -1;
        let pid = (modifierId) ? modifierId : (this.state.selectedMenuId != -1) ? this.state.selectedMenuId : obj.parentModifierId;
        // let pid = (this.state.selectedMenuId != -1) ? this.state.selectedMenuId : obj.parentModifierId;
        let tempList = this.state.selectedModifiersList.get(pid) || [];
        tempList.push(obj);
        this.state.selectedModifiersList.set(pid, tempList);
        tempList.map((lst, index) => {
            if (lst.value == obj.value) {
                getIndex = index;
            }
        });
        if (getIndex == -1) {
            tempList.push(obj);
            this.state.selectedModifiersList.set(pid, tempList);
        }

    }
    removeDefaultModifiersList(id) {
        this.state.defaultModifiersList.set(id, []);
    }

    removeSelectedModifiersList(obj, type, id) {
        if (type == "all") {
            this.state.selectedModifiersList.delete(obj.value);
        } else {
            let pid = id || obj.parentModifierId;

            let tempList = this.state.selectedModifiersList.get(pid);
            let removeIdex = -1;
            if (tempList != undefined) {
                tempList.map((lst, index) => {
                    if (lst.value == obj.value) {
                        removeIdex = index;
                    }
                });
                if (removeIdex != -1) tempList.splice(removeIdex, 1);
                this.state.selectedModifiersList.set(pid, tempList);
            }
        }

    }
    removeSelectedMap(id, selectedModifierId) {
        let temp = this.state.selectedMap.get(selectedModifierId) || [];
        let removeIdex = -1;
        temp.map((lst, index) => {
            if (lst.id == id) {
                removeIdex = index;
            }
        });
        if (removeIdex != -1)
            temp.splice(removeIdex, 1);

        this.state.selectedMap.set(selectedModifierId, temp);

    }
    removeidMap(id, selectedModifierId) {
        let temp = this.state.idMaps.get(selectedModifierId) || [];
        let removeIdex = -1;
        temp.map((lst, index) => {
            if (lst.id == id) {
                removeIdex = index;
            }
        });
        if (removeIdex != -1)
            temp.splice(removeIdex, 1);

        this.state.idMaps.set(selectedModifierId, temp);

    }
    removeselectedSubItems(id) {
        let temp = this.state.selectedSubItems;
        let removeIdex = -1;
        temp.map((lst, index) => {
            if (lst.id == id) {
                removeIdex = index;
            }
        });
        if (removeIdex != -1) {
            temp.splice(removeIdex, 1);
        }
        this.setState({
            selectedSubItems: temp
        })

    }
    updateselectedSubItems(obj, action) {
        let temp = this.state.selectedSubItems;
        if (action == "add") {
            temp.push(obj);
            this.setState({
                selectedSubItems: temp
            })
        } else {
            let removeIdex = -1;
            temp.map((lst, index) => {
                //console.log(lst);
                if (lst.id == obj.id) {
                    removeIdex = index;
                    //console.log(index);
                }
            });
            if (action == "getindex") {
                return removeIdex;
            } else {
                temp.splice(removeIdex, 1);

                this.setState({
                    selectedSubItems: temp
                });
            }
        }
    }
    getTotalPrice() {
        let count = this.state.count;
        let price = this.state.updatedTotalPrice;
        if (count > 0) {
            return price * count;
        }
        return price.toFixed(2);
    }

    handleModalClose() {
        //console.log('Clicked closed -------------------------', this.state.selectedMap, ' ------- ', this.state.selectedSubItems);
        $('.rightSubWrapper').attr('tabindex', '0').focus();
        const labelArray = [];
        const hierarchyData = [];
        let arrayTemp = this.state.selectedMap.has(this.state.selectedMenuId) ? this.state.selectedMap.get(this.state.selectedMenuId) : [];
        let allSelecteData = this.state.selectedSubItems;
        if (arrayTemp.length > 0) {
            let arrayMerge = arrayTemp.concat(allSelecteData);
            arrayTemp = arrayMerge.filter((obj, index, self) =>
                index === self.findIndex((t) => t.id === obj.id)
            );
            /*arrayTemp = arrayMerge.filter((item, index) =>
                arrayMerge.indexOf(item) == index
            )*/
        } else {
            arrayTemp = this.state.selectedSubItems;
        }
        // this.state.selectedSubItems = [];
        this.state.selectedMap.set(this.state.selectedMenuId, arrayTemp);
        this.state.idMaps.set(this.state.selectedMenuId, arrayTemp);
        let updatedMap = this.state.idMaps ? this.state.idMaps : new Map();

        this.state.selectedMap && this.state.selectedMap.get(this.state.selectedMenuId)
            .map((item, index) => {
                labelArray.push(item.name);
                let details = this.getSelectedModiferDetails(item.id);
                //console.log("this.state.selectedMenuId", this.state.selectedMenuId);
                if (details.parentModifierId == this.state.selectedMenuId || details.parentGroupId == this.state.selectedMenuId) {

                    let data = {
                        "id": item.id,
                        "name": item.name,
                        "baseCal": item.baseCal,
                        "price": item.price,
                        "image": item.image,
                        "order": item.order || 1,
                        "componentDisplay": item.componentDisplay
                    }
                    let pindex = -1;
                    hierarchyData.map((item, ind) => {
                        if (item.id == details.parentGroupId || item.id == details.parentOptionGroupId) {
                            pindex = ind;
                        }
                    })
                    if (pindex != -1) {
                        hierarchyData.splice(pindex + 1, 0, data);
                    } else {
                        hierarchyData.push(data);
                    }
                }

            });
        updatedMap.set(this.state.selectedMenuId, hierarchyData);
        document.body.classList.remove("modal-open");

        this.setState({ showHideModal: false, accordionList: labelArray, idMaps: updatedMap }, () => {
            console.log(updatedMap, 'updatedMap');
            console.log(this.state.accordionList, 'accordionListWWWW');
        });

        // Remove add protein if no child is saved
        let _noChild = this.state.idMaps.get(this.state.selectedMenuId);
        if (_noChild.length == 1) {
            if (_noChild[0].componentDisplay == 4 || _noChild[0].componentDisplay == 2) {
                $(".PdpAccordionWrapper .accordion-body." + _noChild[0].id).click();
            }

            if (_noChild[0].componentDisplay == 6) {
                this.state.selectedMap.delete(this.state.selectedMenuId);
                this.state.idMaps.delete(this.state.selectedMenuId);
                this.state.removeSelectedModifiersList({ value: this.state.selectedMenuId }, "all");
            }
        }

    }

    removeModalSelectedIds(id) {
        let list = this.state.finalModalList;
        list.splice(list.indexOf(id), 1)
        this.setState({ finalModalList: list }, () => {
            //console.log("finalModalList===", this.state.finalModalList)

        });
    }

    handleModalSelectedIds(id) {
        this.setState({ finalModalList: id }, () => {
            console.log("finalModalList===", this.state.finalModalList)

        });
    }

    handleAccordionSelectedIds(id) {
        this.setState({ finalAccordionList: id }, () => {
            //console.log("finalAccordionList=====", this.state.finalAccordionList)
        })
    }

    handleSteakTempId(id) {
        let previousId = this.state.finalSteakTempList;

        let index = this.state.finalModalList.indexOf(previousId);
        if (index !== -1) {
            this.state.finalModalList.splice(index, 1)
        }
        //console.log("previousId --> ", previousId, this.state.finalModalList);
        this.setState({ finalSteakTempList: id }, () => {
            //console.log("finalSteakTempList=====", this.state.finalSteakTempList)
        })
    }
    setParentGrpToCountMap(value) {
        this.setState({ parentGrpToCountMap: value }, () => {
            this.handleModalClose();
            //console.log("parentGrpToCountMap=====", this.state.parentGrpToCountMap)
        })
    }
    getParentIdByValue(searchValue) {
        let map = this.state.parentGrpToCountMap;

        for (let [key, value] of map.entries()) {
            if (value.indexOf(searchValue) > -1 && key)
                return key;
        }
    }

    getParentIds(modifiers, selectedMenuId) {
        for (let i = 0; modifiers.optionGroups && i < modifiers.optionGroups.length; i++) {
            for (let j = 0; modifiers.optionGroups[i].Modifiers && j < modifiers.optionGroups[i].Modifiers.length; j++) {
                if (modifiers.optionGroups[i].Modifiers[j].MenuItemDetail.Id == selectedMenuId) {
                    return modifiers.MenuItemDetail.Id;
                } else {
                    this.state.modalListWithParent.push(modifiers.optionGroups[i].Modifiers[j].MenuItemDetail.Id);
                    let menuDetils = this.getParentIds(modifiers.optionGroups[i].Modifiers[j], selectedMenuId);
                    if (menuDetils) {
                        return menuDetils;
                    } else {
                        this.state.modalListWithParent.pop();
                    }
                }
            }
        }
    }

    ValidateOptionSelection() {
        var isValid = false;
        if ($(".PdpAccordionWrapper .accordion-button.required").length > 0) {
            let errorElement = $(".PdpAccordionWrapper .accordion-button.required:not(:has(.completed))");
            $(errorElement).addClass("requiredError");
            if (errorElement.length > 0) {
                let errorMsg = $(errorElement[0]).data("option-title");

                $(".pdplanding-error.alert-dismissible").removeClass("hidden");
                $('.pdplanding-error.alert-dismissible .alert-message').text("Oops! Please make the required selection '" + errorMsg + "'");
                $(".pdplanding-error.alert-dismissible").show();
                if ($(window).width() < 993) {
                    $('html, body').animate({
                        scrollTop: $(errorElement[0]).offset().top - $(window).height() / 2
                    }, 2000);
                    //close all accordion
                    $(".accordion-button").attr("aria-expanded", "false");
                    $(".accordion-button").removeClass("collapsed");
                    $(".accordion-collapse").removeClass("show");
                }

                return false;


            }
        }


        // If Steak Temperature is present
        if (this.state.val === 1 && $(".tempSelectWrapper .tempSelect .rounded-circle.form-check-input").length < 1) {
            $(".reqdText").text("(Required)");
            $(".reqdText").addClass("reqdAlertText");
            $(".pdplanding-error.alert-dismissible").removeClass("hidden");
            $('.pdplanding-error.alert-dismissible .alert-message').text("Oops! Please make a selection for ‘" + $('.reqdText').attr("data-group-name") + "’");
            $(".pdplanding-error.alert-dismissible").show();
            // nested scroll desktop and mobile
            if ($(window).width() >= 993) {
                //$("html, body").animate({
                //    scrollTop: $(".pdpRightWrapper").offset().top - 50
                //});
                //$(".rightSubWrapper").scrollTop(0);

                //close all accordion
                //$(".accordion-button").attr("aria-expanded", "false");
                //$(".accordion-button").removeClass("collapsed");
                //$(".accordion-collapse").removeClass("show");
            }
            else {
                $('html, body').animate({
                    scrollTop: $("p.reqdAlertText").offset().top - $(window).height() / 2
                }, 2000);
                //close all accordion
                $(".accordion-button").attr("aria-expanded", "false");
                $(".accordion-button").removeClass("collapsed");
                $(".accordion-collapse").removeClass("show");
            }
            return isValid;
        }

        // If ComponentType 3 dropdown is present
        if ($(".PdpAccordionWrapper .pdp-dropdown-option").length > 0) {
            //drop down value is not selected
            if ($(".drop-down-container.wrapper .dropdown.Option.true").length < 1) {
                $(".maxOneDropdown.Option .invalid-feedback").show();
                $(".pdplanding-error.alert-dismissible").removeClass("hidden");
                $('.pdplanding-error.alert-dismissible .alert-message').text("Oops! Please make a selection for ‘" + $('.maxOneDropdown.Option').attr("data-group-name") + "’");
                $(".pdplanding-error.alert-dismissible").show();
                // nested scroll desktop and mobile
                if ($(window).width() >= 993) {
                    //$("html, body").animate({
                    //    scrollTop: $(".pdpRightWrapper").offset().top - 50
                    //});
                    //$(".rightSubWrapper").scrollTop(0);

                    //close all accordion
                    //$(".accordion-button").attr("aria-expanded", "false");
                    //$(".accordion-button").removeClass("collapsed");
                    //$(".accordion-collapse").removeClass("show");
                }
                else {
                    $('html, body').animate({
                        scrollTop: $("p.Required").offset().top - $(window).height() / 2
                    }, 2000);
                    //close all accordion
                    $(".accordion-button").attr("aria-expanded", "false");
                    $(".accordion-button").removeClass("collapsed");
                    $(".accordion-collapse").removeClass("show");
                }
                return false;
            }
        }


        $(".alert-dismissible").fadeOut();
        //Drop down option group is present and required is not completed
        if ($(".pdp-dropdown-header .Required").length > 0) {
            document.querySelectorAll('.pdp-dropdown-header .Required').forEach((item, index) => {
                $(item).css("background-color", "red");
            });
            return false;
        }
        return true;
    }
    AddProductToBag(finalIdsValue) {
        if (this.state.updatedTotalPrice == "0.00" || this.state.updatedTotalPrice == 0) {
            if (DE.AlertMessageBar) {
                try {
                    var alert = {
                        AlertMessage: {},
                        RelatedItems: []
                    }
                    alert.AlertMessage.Message = this.state.allData.priceUnavailableError;
                    alert.AlertMessage.Type = 3;
                    DE.AlertMessageBar.handleAlert(alert);
                    if (DE.ProgressIndicator) {
                        DE.ProgressIndicator.hideIndicator();
                    }
                } catch (e) {
                    console.log("error: ", e);
                }
            }
            return false;
        }
        try {
            if (DE.ProgressIndicator) {
                DE.ProgressIndicator.showIndicator();
            }
            var quantityValue = eval($('.quantityinput').val());
            var basketProduct = new Object();
            basketProduct.productid = $("#hdnProductId").val();
            basketProduct.quantity = quantityValue;
            basketProduct.options = finalIdsValue.toString();
            basketProduct.chainProductId = $("#hdnChainProductId").val();
            if ($(".allergyInstruction").val() != '' && $(".allergyInstruction").val() != undefined) {
                basketProduct.specialinstructions = $(".allergyInstruction").data("allergytextprefix") + $(".allergyInstruction").val();
            }

            var basketId = $("#basketId").val();
            var basketProductId = $("#hdnBasketProductId").val();
            var token = $("input[name='__RequestVerificationToken']").val();
            var menuUrl = $(this).attr('data-menuUrl');

            var objBasket = new Object();
            objBasket.basketId = basketId;
            objBasket.basketProductId = basketProductId;
            objBasket.product = basketProduct;
            objBasket["__RequestVerificationToken"] = token;
            var apiUrl = "/api/dineequity/menu2/basket/product/add";
            var httpMethod = "POST";

            if ((basketProductId != undefined || basketProductId != "") && basketProductId != "0") {
                apiUrl = "/api/dineequity/menu2/basket/product/update";
                httpMethod = "PUT";
            }
            console.log('request-->' + apiUrl);
            console.log(JSON.stringify(objBasket));

            $.ajax({
                method: httpMethod,
                url: apiUrl,
                data: objBasket,
                cache: false
            }).done(function (response) {
                //console.log(JSON.stringify(response));
                //ToDo - Need to include GTM code for add and update calls when needed
                if (response.basket && (!response.basket.error || response.basket.error.num == 201)) {
                    if (response.AlcoholItem) {
                        if (DE.AlertMessageBar) {
                            try {
                                var alert = {
                                    AlertMessage: {},
                                    RelatedItems: []
                                }
                                alert.AlertMessage.Message = "Alcohol is unavailble for delivery";
                                alert.AlertMessage.Type = 3;
                                DE.AlertMessageBar.handleAlert(alert);
                                if (DE.ProgressIndicator) {
                                    DE.ProgressIndicator.hideIndicator();
                                }
                            } catch (e) {
                                console.log("error: ", e);
                            }
                        }
                    }
                    else {
                        //ToDo -Need to check if below call is needed or not
                        // DE.Bag.UpdateCartBadge();
                        //ToDo - need to check update product logic 
                        if (basketProductId || basketProductId != "0") {
                            var carturl = $('.cnw-customization').attr('carturl');
                            carturl = carturl == undefined ? menuUrl : carturl;
                            if ($(".text").attr('data-event') == 'Update') {
                                window.location.href = carturl + '?itemedit=1&itemadded=1';
                                return false;
                            }
                            if ($(".pdpRightWrapper").attr('data-event') == 'Update') {
                                try {
                                    var itemName = $('.ItemName.showDesktop').text();
                                    var category = $('.menuRightLink').text();
                                    var oldquantity = $('#hdnCartQuantity') != undefined ? $('#hdnCartQuantity').val() : '';
                                    if (oldquantity != '' && basketProduct.quantity != '') {
                                        var delta = '';
                                        var totalprice = $('.btn-add-cart').text();
                                        totalprice = totalprice ? totalprice.substring(totalprice.lastIndexOf("$") + 1) : undefined;
                                        if (httpMethod == "POST") {
                                            delta = basketProduct.quantity;
                                        }
                                        else if (parseInt(oldquantity) > parseInt(basketProduct.quantity)) {
                                            delta = parseInt(oldquantity) - parseInt(basketProduct.quantity);
                                        }
                                        else if (parseInt(oldquantity) < parseInt(basketProduct.quantity)) {
                                            delta = parseInt(basketProduct.quantity) - parseInt(oldquantity);
                                        }
                                        var menuitems = [{
                                            item_id: basketProduct.chainProductId,
                                            item_name: itemName,
                                            item_brand: 'applebees',
                                            item_category: category,
                                            item_list_name: category,
                                            item_list_id: $('.pdpLandingWrapper').attr('data-categoryid'),
                                            price: totalprice,
                                            index: undefined,
                                            quantity: delta.toString()
                                        }];
                                        if (parseInt(oldquantity) < parseInt(basketProduct.quantity) || httpMethod == "POST") {
                                            GTMHelper.pushGA4AddToCartToGTMDataLayer('menu', menuitems, 'PDP');
                                        }
                                        if (parseInt(oldquantity) > parseInt(basketProduct.quantity)) {
                                            GTMHelper.pushGA4RemoveFromCartToGTMDataLayer(menuitems);
                                        }
                                    }
                                }
                                catch (e) {
                                    console.log("error: ", e);
                                }
                                window.location.href = '/en/order/cart?itemedit=1&itemadded=1'
                            }
                        }
                        window.location.href = response.redirectUrl + '?itemedit=1&itemadded=1';
                    }
                } else {

                    if (DE.ProgressIndicator) {
                        DE.ProgressIndicator.hideIndicator();
                    }
                    if (DE.AlertMessageBar) {
                        var errorMsg = 'unable to add item to cart.';
                        try {
                            var alert = {
                                AlertMessage: {},
                                RelatedItems: []
                            }
                            if (response.basket && response.basket.error) {
                                errorMsg = response.basket.error.message;
                            }
                            alert.AlertMessage.Message = errorMsg;
                            alert.AlertMessage.Type = 3;
                            DE.AlertMessageBar.handleAlert(alert);
                        } catch (e) {
                            console.log(errorMsg);
                        }
                    }
                }
            }).fail(function () {
                if (DE.ProgressIndicator) {
                    DE.ProgressIndicator.hideIndicator();
                }
                if (DE.AlertMessageBar) {
                    try {
                        var alert = {
                            AlertMessage: {},
                            RelatedItems: []
                        };
                        alert.AlertMessage.Message = "An unexpected error occurred";
                        alert.AlertMessage.Type = 3;
                        DE.AlertMessageBar.handleAlert(alert);
                    } catch (e) {
                        console.log('unable to add item to bag.');
                    }
                }
            });

        }
        catch (e) {
            if (DE.ProgressIndicator) {
                DE.ProgressIndicator.hideIndicator();
            }
        }
    }
    AcceptOver21() {
        try {
            DE.Bag.SetOver21Cookie('1');
            this.dataChoiceIds();
        }
        catch (e) {
            console.log(e);
        }
    };
    modalClose() {
        var ageVerifyModal = document.getElementById("ageVerifyModalPdp");
        ageVerifyModal.style.display = "none";
        ageVerifyModal.classList.remove("show");
    }
    dataChoiceIds() {
        var isValid = this.ValidateOptionSelection();
        if (!isValid) { return }
        this.state.modalListWithParent = [];
        this.state.finalModalList.map((id) => {
            this.props.data.ModifierGroups.map(modifierGroups => {
                modifierGroups.Modifiers.map(optModifier => {
                    let parent = this.getParentIds(optModifier, id);
                    if (parent) {
                        this.state.modalListWithParent.push(optModifier.MenuItemDetail.Id);
                        this.state.modalListWithParent.push(parent);
                    }
                });
            });
        });
        let uniqueParentIds = [];
        this.state.modalListWithParent.forEach(element => {
            if (!uniqueParentIds.includes(element)) {
                uniqueParentIds.push(element);
            }
        });
        /*        
                console.log("this.state.finalModalList ---------------------> ", this.state.finalModalList);
                console.log("this.state.finalAccordionList ---------------------> ", this.state.finalAccordionList);
                console.log("this.state.finalSteakTempList ---------------------> ", this.state.finalSteakTempList);
                console.log("uniqueParentIds ---------------------> ", uniqueParentIds);*/
        const finalIdsValue = this.state.finalModalList.concat(uniqueParentIds).concat(this.state.finalAccordionList).concat(this.state.finalSteakTempList);
        let uniquefinalIdsValue = [];
        finalIdsValue.forEach(element => {
            if (!uniquefinalIdsValue.includes(element)) {
                uniquefinalIdsValue.push(element);
            }
        });
        //console.log("finalIdsValue===555555===", uniquefinalIdsValue)
        this.setState({ dataChoiceAttributeIds: uniquefinalIdsValue }, () => {
            //console.log("dataChoiceAttributeIds=====", this.state.dataChoiceAttributeIds)
        })
        console.log("defval======", uniquefinalIdsValue)

        var AddBtn = document.getElementsByClassName("btn-add-cart")[0];
        var alcoholProduct = "";
        if (AddBtn != null) {
            alcoholProduct = AddBtn.getAttribute("data-alcohol");
        }
        if (alcoholProduct == "true") {
            try {
                var over21 = DE.Bag.GetOver21Cookie();
                var ageVerifyModal = document.getElementById("ageVerifyModalPdp");
                if (over21 != "") {

                    if (over21 == '1') {
                        this.AddProductToBag(uniquefinalIdsValue);
                    }
                }
                else {
                    ageVerifyModal.style.display = "block";
                    ageVerifyModal.classList.add("show");
                }
            }
            catch (e) {
                console.log(e);
            }
        }
        else {
            this.AddProductToBag(uniquefinalIdsValue);
        }
    }

    checkMaxCount(selectedModifierId, max, parentId, action, type) {
        let parentChildArray = this.state.parentGrpToCountMap.get(parentId) || [];
        if (parentChildArray.length > 0 && action == 'remove') {
            parentChildArray.splice(parentChildArray.indexOf(selectedModifierId), 1);
            if (parentChildArray.length == 0) {
                this.state.parentGrpToCountMap.delete(parentId);
            }
        }
        if (parentChildArray.indexOf(selectedModifierId) >= 0) {
            return true;
        } else {
            let len = parentChildArray.length;

            if (max == null || max == undefined) {
                max = 10000;
            }

            if (len < max) {
                if (action == 'add') {
                    parentChildArray.push(selectedModifierId);
                }
                this.state.parentGrpToCountMap.set(parentId, parentChildArray);
                return true;
            } else {
                this.state.parentGrpToCountMap.set(parentId, parentChildArray);
                if (type == 'multi') {
                    if (!this.state.parentGrpToCountMap.has(selectedModifierId)) {
                        this.state.parentGrpToCountMap.set(selectedModifierId, []);
                    }
                    if (parentChildArray.indexOf(selectedModifierId) >= 0) {
                        return true;
                    }
                } else {
                    return false;
                }
            }
        }
    }

    updateTotalPrice(price, action, id) {
        if (action == "substitute" || action == "child") {
            if (this.state.priceSplitUp.get(id))
                price = "" + this.state.priceSplitUp.get(id).price;
            else
                price = "0";
        }

        if (typeof price === 'string') price = price.replace(/\$/g, '');
        price = parseFloat(price);

        let tPrice = parseFloat(this.state.updatedTotalPrice);
        let arr = {
            "id": id,
            "price": price
        };
        if (action == "add") {
            if (!this.state.priceSplitUp.has(id)) {
                tPrice = tPrice + price;
                this.state.priceSplitUp.set(id, arr);
            }
        } else {
            if (this.state.priceSplitUp.has(id)) {
                tPrice = tPrice - price;
                this.state.priceSplitUp.delete(id);
            }

        }

        this.setState({
            updatedTotalPrice: parseFloat(tPrice).toFixed(2)
        });
        this.state.updatedTotalPrice = parseFloat(tPrice).toFixed(2);
        //console.log("updated price" + this.state.updatedTotalPrice);
    }

    increaseCounter() {
        this.setState((prevState, { count }) => ({
            count: prevState.count + 1
            //updatedTotalPrice: ((this.state.updatedTotalPrice * (this.state.count + 1)) / (this.state.count)).toFixed(2)
        }));
    };

    decreaseCounter() {
        if (this.state.count > 1) {
            this.setState((prevState, { count }) => ({
                count: prevState.count - 1
                //updatedTotalPrice: ((this.state.updatedTotalPrice / this.state.count) * (this.state.count - 1)).toFixed(2)
            }));
        }
    };
    handleClick(title, selectedMenuId, isRequired, modifiers, parentId) {
        let existingData = this.state.idMaps.has(selectedMenuId) ? this.state.idMaps.get(selectedMenuId) : [];
        if (existingData.length == 0) {
            this.state.idMaps.set(selectedMenuId, existingData);
            //this.state.selectedMap.set(selectedMenuId, existingData);
            // this.state.selectedSubItems = existingData;
        }
        //this.state.selectedMap.set(selectedMenuId, existingData);        
        if (!this.state.selectedMap.has(selectedMenuId)) {
            this.state.selectedMap.set(selectedMenuId, new Array());
            //this.state.selectedSubItems = [];
        } else {
            this.state.selectedSubItems = this.state.selectedMap.get(selectedMenuId);
        }
        this.state.parentId = parentId;
        const idArray = [];
        this.state.selectedSubItems.map((selectedSubItem) => {
            idArray.push(selectedSubItem.name);
        });

        this.setState({
            showHideModal: true, modalTitle: title, selectedRootModifiers: modifiers, selectedMenuId: selectedMenuId,
            isRequired: isRequired, accordionList: idArray, idMaps: this.state.idMaps
        });
        console.log(" Final modal list ********************************", this.state.finalModalList);

    }
    setEditData(menuId, modifiers, parentDetails, parentModifierId, gid) {
        if (this.state.isEditMode == true && this.state.editValues.length > 0 && this.state.editValues.indexOf(modifiers.MenuItemDetail.Id) > -1) {
            let pid = (parentDetails.GroupDisplay == 0 || parentDetails.GroupDisplay == -1) ? menuId : parentDetails.id;
            //if (modifiers.ComponentDisplay != 4 && modifiers.ComponentDisplay != 6) {
            let data = {
                "id": modifiers.MenuItemDetail.Id,
                "name": modifiers.MenuItemDetail.Name,
                "baseCal": modifiers.MenuItemDetail.BaseCalories,
                "price": modifiers.MenuItemDetail.CalcPrice,
                "order": parentDetails.order || 1,
                "image": modifiers.MenuItemDetail.ImagePath,
                "componentDisplay": modifiers.ComponentDisplay
            }
            let uniquefinalIdsValue = this.state.finalModalList;
            if (uniquefinalIdsValue.indexOf(modifiers.MenuItemDetail.Id) == -1) {
                let hierarchyData = this.state.idMaps.get(pid) || [];
                hierarchyData.push(data);
                this.state.idMaps.set(pid, hierarchyData);
                this.state.selectedMap.set(pid, hierarchyData);
                this.state.selectedSubItems = [...this.state.selectedSubItems, data]

                uniquefinalIdsValue.push(modifiers.MenuItemDetail.Id);
                this.setState({ finalModalList: uniquefinalIdsValue }, () => {
                });
                this.updateTotalPrice(modifiers.MenuItemDetail.Price, "add", modifiers.MenuItemDetail.Id);
                this.checkMaxCount(modifiers.MenuItemDetail.Id, parentDetails.maxSelect, parentDetails.id, 'add');
                let selectItem = {};
                selectItem.value = modifiers.MenuItemDetail.Id;
                selectItem.label = modifiers.MenuItemDetail.Name;
                selectItem.baseCal = modifiers.MenuItemDetail.BaseCalories;
                selectItem.price = modifiers.MenuItemDetail.CalcPrice;
                selectItem.image = modifiers.MenuItemDetail.ImagePath;
                selectItem.order = parentDetails.order || 1;
                selectItem.componentDisplay = modifiers.ComponentDisplay;
                selectItem.parentModifierId = pid;
                selectItem.parentGroupId = parentDetails.id || pid;
                selectItem.parentOptionGroupId = parentModifierId || pid;
                this.setSelectedModifiersList(selectItem, pid);

                this.setState({
                    selectedSubItems: this.state.selectedSubItems,
                });
            }



            //}
            let showDisplaEle = document.getElementById(pid + "-checkClick");

            if (showDisplaEle != null && !showDisplaEle.classList.contains('firstClick')) {
                showDisplaEle.classList.add("show");
                showDisplaEle.classList.remove("hideCheckClick");
                showDisplaEle.classList.add("firstClick");
            }
        }
        if (modifiers.optionGroups.length > 0) {
            modifiers.optionGroups.map((optionGroup) => {
                let pDetails = {
                    "id": optionGroup.Id,
                    "maxselects": optionGroup.maxselects,
                    "GroupDisplay": -1,
                    "order": (modifiers.ComponentDisplay == 3) ? 2 : 1
                }
                optionGroup.Modifiers.map((groupmodifier) => {
                    this.setEditData(menuId, groupmodifier, pDetails, modifiers.MenuItemDetail.Id);
                })
            })
        }

    }
    checkDirectChildHasDefault(optionGroups) {
        let id = [];
        optionGroups.map((optionGroup) => {
            optionGroup.Modifiers.map((groupmodifier) => {
                if (groupmodifier.MenuItemDetail.IsDefault == true) {
                    id.push(groupmodifier.MenuItemDetail.Id);
                }
            })
        })
        return id;
    }
    setDefaultData(level, sidechildIds, menuId, modifiers, parentDetails, parentModifierId, gid) {
        let allowed = false;
        if (modifiers.ComponentDisplay == 6 || modifiers.ComponentDisplay == 7) {
            //just highlight component like side
            let childIds = this.checkDirectChildHasDefault(modifiers.optionGroups);
            if (childIds.length > 0) {
                allowed = true;
            }
            if (level == 0) {
                sidechildIds = sidechildIds.concat(childIds);
            }
        }
        if (modifiers.ComponentDisplay == 7 || modifiers.ComponentDisplay == 5) {
            let childIds = this.checkDirectChildHasDefault(modifiers.optionGroups);
            if (childIds.length > 0) {
                allowed = true;
            }

        }
        if (this.state.isEditMode == false && ((modifiers.MenuItemDetail.IsDefault == true && modifiers.ComponentDisplay != 6) || allowed == true)) {
            let pid = (parentDetails.GroupDisplay == 0 || parentDetails.GroupDisplay == -1) ? menuId : parentDetails.id;

            // if (modifiers.ComponentDisplay != 4) {
            if (this.checkMaxCount(modifiers.MenuItemDetail.Id, parentDetails.maxSelect, parentDetails.id, 'add')) {
                let selectItem = {};
                selectItem.value = modifiers.MenuItemDetail.Id;
                selectItem.label = modifiers.MenuItemDetail.Name;
                selectItem.baseCal = modifiers.MenuItemDetail.BaseCalories;
                selectItem.price = modifiers.MenuItemDetail.CalcPrice;
                selectItem.image = modifiers.MenuItemDetail.ImagePath;
                selectItem.componentDisplay = modifiers.ComponentDisplay;
                selectItem.order = parentDetails.order || 1;
                selectItem.parentModifierId = pid;
                selectItem.parentGroupId = parentDetails.id || pid;
                selectItem.parentOptionGroupId = parentModifierId || pid;
                if (level == 0) {
                    console.log("selectItem -->", selectItem)
                }
                if (level == 0 || (level == 1 && sidechildIds.indexOf(modifiers.MenuItemDetail.Id) > -1)) {
                    let data = {
                        "id": modifiers.MenuItemDetail.Id,
                        "name": modifiers.MenuItemDetail.Name,
                        "baseCal": modifiers.MenuItemDetail.BaseCalories,
                        "price": modifiers.MenuItemDetail.CalcPrice,
                        "order": parentDetails.order || 1,
                        "image": modifiers.MenuItemDetail.ImagePath,
                        "componentDisplay": modifiers.ComponentDisplay
                    }
                    let uniquefinalIdsValue = this.state.finalModalList;
                    if (uniquefinalIdsValue.indexOf(modifiers.MenuItemDetail.Id) == -1) {
                        let hierarchyData = this.state.idMaps.get(pid) || [];
                        hierarchyData.push(data);
                        this.state.idMaps.set(pid, hierarchyData);
                        this.state.selectedMap.set(pid, hierarchyData);
                        this.state.selectedSubItems = [...this.state.selectedSubItems, data]

                        uniquefinalIdsValue.push(modifiers.MenuItemDetail.Id);
                        this.setState({ finalModalList: uniquefinalIdsValue }, () => {
                        });
                        this.updateTotalPrice(modifiers.MenuItemDetail.Price, "add", modifiers.MenuItemDetail.Id);
                        this.setSelectedModifiersList(selectItem, pid);
                    }

                } else {
                    this.setDefaultModifiersList(selectItem, pid);

                }

            }
            // }

        }
        if (modifiers.optionGroups.length > 0) {
            modifiers.optionGroups.map((optionGroup) => {
                let pDetails = {
                    "id": optionGroup.Id,
                    "maxselects": optionGroup.maxselects,
                    "GroupDisplay": -1,
                    "order": (modifiers.ComponentDisplay == 3) ? 2 : 1
                }
                optionGroup.Modifiers.map((groupmodifier) => {
                    this.setDefaultData(level + 1, sidechildIds, menuId, groupmodifier, pDetails, modifiers.MenuItemDetail.Id);
                })
            })
        }

    }
    handleImageLoaded() {
        if ($(window).width() > 992) {
            //console.log("**image loaded**", $(".pdpLandingWrapper .pdpLeftWrapper .ImagePdpWrapper").innerHeight())
            $(".pdpLandingWrapper").css("height", $(".pdpLandingWrapper .pdpLeftWrapper .ImagePdpWrapper").innerHeight());
        }

    }

    componentDidMount() {
        this.state.allData.ModifierGroups.map((ModifierGroup) => {
            const isTempExist = ModifierGroup.GroupDisplay == 2 ? true : false;
            isTempExist === true ? this.setState({ val: 1, steakData: ModifierGroup }) : this.state.val = 0;
        })


        if ($(window).width() > 992) {
            $(".pdpLandingWrapper").css("min-height", $(".pdpLandingWrapper .pdpLeftWrapper .ImagePdpWrapper").innerHeight());
            var img = document.querySelector('img.pdpImage')
            if (img.complete) {
                this.handleImageLoaded()
            } else {
                img.addEventListener('load', this.handleImageLoaded())
                img.addEventListener('error', function () {
                    console.log('error')
                })
            }
        }
        if (this.props.data.CartItem != null && this.props.data.CartItem.choices != null) {
            this.setState({ count: this.props.data.CartItem.quantity });

            let result = this.props.data.CartItem.choices.map(a => a.optionid);

        }
        // Function to preselect the cartitem in edit mode

        this.state.allData.ModifierGroups.map((ModifierGroup) => {
            let parentDetails = {
                "id": ModifierGroup.Id,
                "maxselects": ModifierGroup.maxselects,
                "GroupDisplay": ModifierGroup.GroupDisplay,
            };
            ModifierGroup.Modifiers.map((modifier) => {
                if (this.state.isEditMode == true) {
                    this.setEditData(modifier.MenuItemDetail.Id, modifier, parentDetails);
                } else {
                    this.setDefaultData(0, [], modifier.MenuItemDetail.Id, modifier, parentDetails);
                }
            })
        });



        $(document).ready(function () {
            if ($(window).width() < 993) {
                var title = $('#imgTitle');
                var stickyTop = $("#imgTitle").offset().top + 30;
                window.addEventListener("scroll", () => {
                    var currentScroll = $(this).scrollTop();
                    if (currentScroll > stickyTop) {
                        title.addClass("stickyTitle");
                        $(".stickyModifierElements").removeClass("d-none");
                    } else {
                        title.removeClass("stickyTitle");
                        $(".stickyModifierElements").addClass("d-none");
                        $("#modifierModal .btn-close").trigger('click');
                    }
                }, 3000);
            }

        })

        let $this = this;
        setTimeout(() => $this.handleImageLoaded(), 1000);

        this.pushAppbViewItemToGTMDataLayer();
    }
    /*   GA4 view item event*/
    pushAppbViewItemToGTMDataLayer() {
        try {
            var menuItem = [{
                'item_id': this.props.data.MenuItem.ChainProductId.toString(),
                'item_name': this.props.data.MenuItem.Name,
                'item_brand': 'applebees',
                'item_category': this.props.breadcrumbData.CategoryName,
                'item_list_name': this.props.breadcrumbData.CategoryName,
                'item_list_id': this.props.data.CategoryID.toString(),
                'price': this.props.data.MenuItem.Price.trim().replace('$', ''),
                'quantity': '1'
            }];
            GTMHelper.pushViewItemToGTMDataLayer(menuItem)
        }

        catch (e) {
            console.log(e);
        }
    }

    render() {

        const { showHideModal, allData, modalTitle, selectedRootModifiers, selectedMenuId,
            isRequired, selectedSubItems, selectedMap, parentId, finalModalList,
            dataChoiceAttributeIds, steakData, parentGrpToCountMap, idMaps, defaultModifiersList, isOnline } = this.state;

        return (
            <div>

                <section className="pdpLandingWrapper" data-categoryID={this.props.data.CategoryID}>

                    <div className="pdpLeftWrapper">
                        <PdpHero idMaps={idMaps} data={this.props.data.MenuItem} breadcrumbData={this.props.breadcrumbData} selectedSubItems={selectedSubItems} />
                    </div>
                    {isOnline &&
                        <div className="pdpRightWrapper" id="scroll" data-Event={this.props.data.CartItem != null ? "Update" : ""}>
                            <div className="rightSubWrapper">
                                {this.state.val === 1 ?
                                    <PdpSteakTemperature SteakDescription={allData.SteakDescription} data={steakData} handleSteakTempId={(id) => this.handleSteakTempId(id)} CartItem={this.props.data.CartItem} handleModalSelectedIds={(id) => this.handleModalSelectedIds(id)} /> :
                                    ""
                                }


                                <PdpAccordion data={allData} selectedSubItems={selectedSubItems} handleClick={this.handleClick}
                                    parentId={parentId}
                                    accordionList={finalModalList}
                                    inDex={this.state.val}
                                    isEditMode={this.state.isEditMode}
                                    editValues={this.state.editValues}
                                    selectedMap={selectedMap}
                                    parentGrpToCountMap={parentGrpToCountMap}
                                    checkMaxCount={(selectedModifierId, label, max, parentId) => this.checkMaxCount(selectedModifierId, label, max, parentId)}
                                    handleModalSelectedIds={(id) => this.handleModalSelectedIds(id)}
                                    removeModalSelectedIds={(id) => this.removeModalSelectedIds(id)}
                                    getCaloriesDetails={(modifiers, selectedArray) => this.getCaloriesDetails(modifiers, selectedArray)}
                                    CalorieAdds={allData.CalorieAdds}
                                    CalorieAbbr={allData.CalorieAbbr}
                                    CalorieSubtracts={allData.CalorieSubtracts}
                                    removeSelectedMap={(id, selectedModifierId) => this.removeSelectedMap(id, selectedModifierId)}
                                    removeidMap={(id, selectedModifierId) => this.removeidMap(id, selectedModifierId)}
                                    removeselectedSubItems={(id) => this.removeselectedSubItems(id)}
                                    updateselectedSubItems={(obj, action) => this.updateselectedSubItems(obj, action)}
                                    idMaps={idMaps}
                                    getAllselectedChildModifiers={(parentId, groupId, isNested) => this.getAllselectedChildModifiers(parentId, groupId, isNested)}

                                    setSelectedModifiersList={(obj, mid) => this.setSelectedModifiersList(obj, mid)}
                                    removeSelectedModifiersList={(obj, type, mid) => this.removeSelectedModifiersList(obj, type, mid)}
                                    getParentIdByValue={(value) => this.getParentIdByValue(value)}
                                    updateTotalPrice={(price, action, id) => this.updateTotalPrice(price, action, id)}
                                    CartItem={this.props.data.CartItem} selectedModifiers={finalModalList} CartItem={this.props.data.CartItem}
                                />
                                {(this.props.data.DisplayAllergyInstruction == true) &&
                                    <div className="menu-allergyinstruction">
                                        <div className="allegry-header">
                                            <p className="header-desc">{this.props.data.AllergyHeading} <span className="p2 optional">{allData.OptionalText}</span></p>
                                        </div>
                                <textarea id="allergyInstruction" className="allergyInstruction p2" placeholder={this.props.data.AllergyPlaceholderText} maxLength={this.props.data.AllergyInstructionMaxLength} data-allergyTextPrefix={this.props.data.AllergyTextPrefix} rows="5">{this.props.data.CartItem.specialinstructions}</textarea>
                                        <p className="p2">{this.props.data.AllergyFooter}</p>
                                    </div>
                                }

                                {this.disclaimers && this.disclaimers.length > 0 &&
                                    <div className="disclaimerList disclaimer-desc">
                                        {this.disclaimers.map((disclaimer) => {
                                            return (
                                                <p className="small-text">{disclaimer.disclaimer}</p>
                                            );
                                        })
                                        }
                                    </div>
                                }

                                {this.trademarks && this.trademarks.length > 0 &&
                                    <div className="disclaimerToggle disclaimer-toggle">
                                        <a href="#" className="small-text disclaimerText collapsed" data-bs-toggle="collapse" data-bs-target="#toggleText" aria-expanded="false">
                                            <span className="innerText">Open</span>
                                            <span className="disclaimerCheck"></span>
                                        </a>
                                        <div id="toggleText" className="small-text collapse">
                                            {this.trademarks.map((trademark) => {
                                                return (
                                                    <p className="small-text" dangerouslySetInnerHTML={{ __html: trademark.disclaimer }} />
                                                );
                                            })
                                            }
                                        </div>
                                    </div>
                                }
                            </div>

                        <PdpAddToCartBtn DismissText={allData.DismissText} AllowedMaxQuantity={allData.AllowedMaxQuantity} addToCart={() => this.dataChoiceIds()} dataChoiceAttributeIds={dataChoiceAttributeIds}
                                isAlcohol={this.props.data.MenuItem.IsAlcohol} count={this.state.count} getPrice={() => (this.getTotalPrice()).toFixed(2)}
                                increaseCounter={() => this.increaseCounter()} decreaseCounter={() => this.decreaseCounter()} CartItem={this.props.data.CartItem != null ? this.props.data.CartItem.name : null}
                            />

                        </div>
                    }
                    {!isOnline &&
                        <div className="pdpRightWrapper" id="scroll" >
                            <div className ="rightSubWrapper pb-0">
                            <h3>{allData.defaultStoreTitle}</h3>
                            <p class="p1">{allData.defaultStoreSubtitle}</p>
                            <a href={allData.OrderMethodUrl} className="btn btn-primary btn-lg">{allData.UnavailableOrderOnlineText }</a>
                            </div>
                        </div>
                    }
                    {showHideModal && <PdpModal allData={allData} data={selectedRootModifiers} selectedMenuId={selectedMenuId}
                        handleModalClose={this.handleModalClose} title={modalTitle} isRequired={isRequired}
                        selectedSubItems={selectedSubItems} accordionList={finalModalList}
                        parentGrpToCountMap={parentGrpToCountMap}
                        setParentGrpToCountMap={(value) => this.setParentGrpToCountMap(value)}
                        parentId={parentId}
                        defaultModifiersList={defaultModifiersList}
                        getParentIdByValue={(value) => this.getParentIdByValue(value)}
                        getCaloriesDetails={(modifiers, selectedArray) => this.getCaloriesDetails(modifiers, selectedArray)}
                        setSelectedModifiersList={(obj, mid) => this.setSelectedModifiersList(obj, mid)}
                        updateselectedSubItems={(obj, action) => this.updateselectedSubItems(obj, action)}
                        removeSelectedModifiersList={(obj, type, mid) => this.removeSelectedModifiersList(obj, type, mid)}
                        removeDefaultModifiersList={(id) => this.removeDefaultModifiersList(id)}
                        checkMaxCount={(selectedModifierId, label, max, parentId) => this.checkMaxCount(selectedModifierId, label, max, parentId)}
                        handleModalSelectedIds={(id) => this.handleModalSelectedIds(id)}
                        getAllselectedChildModifiers={(parentId, groupId, isNested) => this.getAllselectedChildModifiers(parentId, groupId, isNested)}
                        errorImg={allData.DefaultModifierImage}
                        CalorieAdds={allData.CalorieAdds}
                        CalorieAbbr={allData.CalorieAbbr}
                        CalorieSubtracts={allData.CalorieSubtracts}
                        updateTotalPrice={(price, action, id) => this.updateTotalPrice(price, action, id)} selectedModifiers={finalModalList}
                        idMaps={idMaps}
                    />}
                    {showHideModal && (<div className="overlay"></div>)}
                </section>
                {isOnline &&
                    <PdpAddToCartFixBtn DismissText={allData.DismissText} AllowedMaxQuantity={allData.AllowedMaxQuantity} addToCart={() => this.dataChoiceIds()} dataChoiceAttributeIds={dataChoiceAttributeIds}
                        isAlcohol={this.props.data.MenuItem.IsAlcohol} count={this.state.count} getPrice={() => (this.getTotalPrice()).toFixed(2)}
                        increaseCounter={() => this.increaseCounter()} decreaseCounter={() => this.decreaseCounter()} CartItem={this.props.data.CartItem != null ? this.props.data.CartItem.name : null} />
                }
                < div className="modal fade ageVerifyModal" tabindex="-1" data-bs-backdrop="static" id="ageVerifyModalPdp">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="btn-close" onClick={() => this.modalClose()} data-bs-dismiss="modal" aria-label="Close">
                                    <i className="o-icon-sm o-icon--close"></i>
                                </button>
                                <h4>{this.props.menuCardData.AlcoholPopupTitle}</h4>
                            </div>
                            <div className="modal-body">
                                <p>{this.props.menuCardData.AlcoholPopupBody}</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default  btn-lg btn-md--no-icon" onClick={() => this.modalClose()} data-bs-dismiss="modal">{this.props.menuCardData.AlcoholPopupNoButtonText}</button>
                                <button type="button" className="btn btn-primary btn-lg btn-md--no-icon" onClick={() => this.AcceptOver21()} data-bs-dismiss="modal">{this.props.menuCardData.AlcoholPopupYesButtonText}</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );

    }
}
